// update along with app/lib/enums/brand_product_outlier_cleanup_enums.py
const BrandProductOutlierCleanupStatus = {
  PENDING: 'PENDING',
  SENT_FOR_OUTLIER_DETECTION: 'SENT_FOR_OUTLIER_DETECTION',
  CLEANED: 'CLEANED',
};

export { BrandProductOutlierCleanupStatus };
